import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H4, Image, LI, P, UL } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useFourListe, { changeStatus, deleteFours } from "./FourApi";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { formatPhoneNumber, truncateText } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { Editor } from '@tinymce/tinymce-react';

type Fours = { [key: string]: any }

const GestFournisseur = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Fours[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const fournis = useFourListe(refresh) || [];
    const [data, setData] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        type: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        type: '',
        id: null
    });

    useEffect(() => {
        const filtered = fournis.filter((item) =>
            item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
        );

        if (JSON.stringify(filtered) !== JSON.stringify(filteredItems)) {
            setFilteredItems(filtered);
        }
    }, [fournis, filterText, filteredItems, refresh]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = data.id !== null ? `${URL_API}/fournisseur/update/${data.id}` : `${URL_API}/fournisseur/create`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "Fournisseur modifié avec succès !!" : "Fournisseur ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }


        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status == 405) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet element ??" : "De vouloir changer le status de cet element",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteFours({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const editerData = ({ id }: { id: number }) => {
        const data = filteredItems.find((item) => item.id === id);
        if (data) {
            setData({
                name: data.name,
                phone: data.phone,
                email: data.email,
                address: data.address,
                type: data.type,
                id: data.id
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const clearDataForm = () => {
        setData({
            name: '',
            phone: '',
            email: '',
            address: '',
            type: '',
            id: null
        });
        setErreur({
            name: '',
            phone: '',
            email: '',
            address: '',
            type: '',
            id: null
        });
    }

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Fournisseurs" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col md="7">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <div className={`theme-scrollbar table-responsive table table-striped bg-info text-center`}>

                                <Table striped={true} hover={true} size={'sm'} responsive={"sm"}>
                                    <thead className={`tbl-strip-thad-bdr`}>
                                        <tr>
                                            <th scope="col">Id</th>
                                            <th scope="col">Nom & Adresse</th>
                                            <th scope="col">E-mail & Téléphone</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {filteredItems.map((item, index) => (
                                            <tr key={item.id} className='text-center'>
                                                <th scope='row'>
                                                    <span className="fw-bold text-dark">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {item.name}
                                                    </span> <br></br>
                                                    <span>
                                                        {item.address}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {formatPhoneNumber(item.phone)}
                                                    </span> <br></br>
                                                    <span>
                                                        {item.email}
                                                    </span>
                                                </td>
                                                <td>
                                                    {item.status === 'actif' ? (
                                                        <Button className="btn btn-xs btn-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                            Activer
                                                        </Button>
                                                    ) : (
                                                        <Button className="btn btn-xs btn-warning" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                            Desactiver
                                                        </Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Btn className='bg-dark btn-xs mx-1 my-1' onClick={() => editerData({ id: item.id })}>
                                                        <i className='fa fa-pencil'></i>
                                                    </Btn>
                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                        <i className='fa fa-trash'></i>
                                                    </Btn>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card>
                    </Col>
                    <Col md="5">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmitData}>
                                    <H4 className="my-4 text-capitalize">
                                        {
                                            data.id == null ? ("Ajouter un founisseur") : ("Modification du founisseur " + data.name)
                                        }
                                    </H4>

                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Nom</Label>
                                                        <Input
                                                            placeholder="Entrer le nom"
                                                            name="name"
                                                            value={data.name}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.name && (
                                                            <span className="text-danger">{erreur.name}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Adresse</Label>
                                                        <Input
                                                            placeholder="Entrer le addresse"
                                                            name="address"
                                                            value={data.address}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.address && (
                                                            <span className="text-danger">{erreur.address}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>E-mail</Label>
                                                        <Input
                                                            placeholder="Entrer le E-mail"
                                                            name="email"
                                                            value={data.email}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.email && (
                                                            <span className="text-danger">{erreur.email}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Téléphone</Label>
                                                        <Input
                                                            placeholder="Entrer le téléphone"
                                                            name="phone"
                                                            value={data.phone}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.phone && (
                                                            <span className="text-danger">{erreur.phone}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Types</Label>
                                                        <Input
                                                            placeholder="Entrer le type"
                                                            name="type"
                                                            value={data.type}
                                                            onChange={changeHandler}
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            <option value=''>Selectionner...</option>
                                                            <option value='normal'>Normal</option>
                                                            <option value='diamond'>Diamond Ciment</option>
                                                            <option value='diamond_sougueta'>Diamond Sougueta</option>
                                                            <option value='cimaf'>CIMAF</option>
                                                            <option value='ciment_de_guinee'>Ciment de Guinée</option>
                                                        </Input>
                                                        {erreur.phone && (
                                                            <span className="text-danger">{erreur.phone}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                        {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                        </Btn>
                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                            Annuler
                                        </Btn>
                                    </div>
                                </Form>
                            </CardBody>

                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>

    )
}

export default GestFournisseur